import { useScrollDepthTracking } from "@/hooks/useScrollDepthTracking";

interface InsightEngagementTrackerProps {
  slug: string;
  title: string;
}

export const InsightEngagementTracker = ({
  slug,
  title,
}: InsightEngagementTrackerProps) => {
  // This hook handles all the tracking logic
  useScrollDepthTracking({
    contentSlug: slug,
    contentTitle: title,
    thresholds: [25, 50, 75, 90, 100],
  });

  // This component doesn't render anything visible
  return null;
};
